<template>
  <v-card class="mx-auto mb-3" flat width="550" elevation="1">
            <v-list-item three-line dense>
              <v-list-item-content>
                <v-list-item-title class="d-flex justify-space-between"
                  ><span> Proceso Admin:</span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Estatus`) }}
                  </span>
                </v-list-item-title>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span> Numero Bultos: </span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Bultos`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span> Transporte: </span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Transporte`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span> Cant Paletas: </span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Paletas`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Ref. Embalaje: </span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Embalaje`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Cant Cajas: </span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Cajas`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Referencia de Viaje:</span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Viaje`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Guia Despacho:</span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Guia`) }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-center flex-column">
                  <span>Observaciones</span>
                  <span class="text-body-2 font-weight-bold">
                    {{ trackCliente(numdoc, `Observ`) }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
           
          </v-card>
</template>

<script>
export default {
    computed:{
        trackCliente: function () {
      return function (id, namefield) {
        const {ttEnvio} = this.detallecliente?.dsDocument;
        if (ttEnvio) {
          const item = ttEnvio.find((x) => x.NumDoc === id);
          return item ? item[namefield] : [];
        }
        return [];
      };
    },
    },
props:{
    detallecliente: Object,
    numdoc: Number
}
}
</script>